
/*****
 * サイトの共通変数
 ****/
export default {

  // console.logの有効化など
  DEBUG: false,

  //WP REST API のパス ローカルと本番で分岐
  API_PATH: process.env.NODE_ENV === 'production'
  ? 'https://tnyu.jp/wp/wp-json/wp/v2/' //本サーバ
  : 'http://tnyu.jp/wp/wp-json/wp/v2/', //ローカル 本サーバと同じデータを取得したい場合は上に同じ
}